(function () {
  if (window.__MY_SCRIPT_INITIALIZED__) return;
  window.__MY_SCRIPT_INITIALIZED__ = true;

  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.getElementById('byos-form__customization-wrapper');
    if (!wrapper) return;

    const addButtons = document.querySelectorAll('.byos-form__add-customization');
    const orderInput = document.getElementById('byos-form__order');
    const nameInput = document.getElementById('byos-form__name');
    const emailInput = document.getElementById('byos-form__email');
    const storeSelect = document.querySelector('select#byos-form__store');
    const submitBtn = document.querySelector('.byos-form__submit');

    const submitError = document.createElement('div');
    submitError.className = 'byos-form__submit-error';
    if (submitBtn) {
      submitBtn.insertAdjacentElement('afterend', submitError);
    }

    function showSubmitError({ summaryLines = [], customizationErrors = [] }) {
      submitError.innerHTML = '';

      summaryLines.forEach((line) => {
        const summary = document.createElement('div');
        summary.className = 'byos-form__submit-error-summary';
        summary.textContent = line;
        submitError.appendChild(summary);
      });

      customizationErrors.forEach(({ label, issues }) => {
        const group = document.createElement('div');
        group.className = 'byos-form__submit-error-group';

        const title = document.createElement('div');
        title.className = 'byos-form__submit-error-title';
        title.textContent = label;
        group.appendChild(title);

        const list = document.createElement('ul');
        list.className = 'byos-form__submit-error-list';
        issues.forEach((issue) => {
          const li = document.createElement('li');
          li.textContent = issue;
          list.appendChild(li);
        });
        group.appendChild(list);

        submitError.appendChild(group);
      });
    }

    function hideSubmitError() {
      submitError.innerHTML = '';
    }

    const BYOS_APP_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyjWRbJzN74Pp8dlIS6tRtixwal7qDaxumVCYPHl7pIHc7kqIDN8vTEYKTWWAFjZ8xv/exec';
    const BYOS_APP_SCRIPT_SECRET = 'G43HKJ8hkkKN64BKJzmJTGDF175sagGDHS789DSgd9s';

    function getByosFieldValue(root, selector, fallback = '') {
      const el = root.querySelector(selector);
      if (!el) return fallback;
      return el.value ? el.value.trim() : fallback;
    }

    const productModal = document.createElement('div');
    productModal.id = 'byos-form__product-modal';
    productModal.className = 'byos-form__modal';
    productModal.innerHTML = `
      <div class="byos-form__modal-dialog">
        <div class="byos-form__modal-header">
          <h3>Choose product</h3>
          <button type="button" class="byos-form__modal-close">×</button>
        </div>
        <div class="byos-form__modal-body">
          <input type="text" class="byos-form__product-search" placeholder="Search product">
          <div class="byos-form__product-results"></div>
        </div>
        <div class="byos-form__modal-footer">
          <button type="button" class="byos-form__modal-cancel">Cancel</button>
          <button type="button" class="byos-form__modal-done" disabled>Done</button>
        </div>
      </div>
    `;
    document.body.appendChild(productModal);

    const productSearchInput = productModal.querySelector('.byos-form__product-search');
    const productResultsEl = productModal.querySelector('.byos-form__product-results');
    const productDoneBtn = productModal.querySelector('.byos-form__modal-done');
    const productCancelBtn = productModal.querySelector('.byos-form__modal-cancel');
    const productCloseBtn = productModal.querySelector('.byos-form__modal-close');

    let activeProductsList = null;
    let productSearchDebounce = null;
    const pendingProductSelections = new Map();

    function renderProductResultsEmpty(message = 'Type at least 2 characters to search') {
      productResultsEl.innerHTML = '';
      const empty = document.createElement('div');
      empty.className = 'byos-form__product-results-empty';

      const icon = document.createElement('span');
      icon.className = 'byos-form__product-results-icon';
      icon.textContent = '🔍';

      const text = document.createElement('span');
      text.textContent = message;

      empty.appendChild(icon);
      empty.appendChild(text);
      productResultsEl.appendChild(empty);
    }

    function renderProductResults(products) {
      productResultsEl.innerHTML = '';

      if (!products.length) {
        renderProductResultsEmpty('No products found.');
        return;
      }

      products.forEach((product) => {
        const group = document.createElement('div');
        group.className = 'byos-form__product-group';
        group.dataset.productId = String(product.id);

        const header = document.createElement('div');
        header.className = 'byos-form__product-header';

        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          header.appendChild(img);
        }

        const label = document.createElement('span');
        label.textContent = product.title;
        header.appendChild(label);

        const toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'byos-form__product-toggle';
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.innerHTML = '&#9662;';
        header.appendChild(toggleBtn);

        const variantsEl = document.createElement('div');
        variantsEl.className = 'byos-form__product-variants is-collapsed';

        group.appendChild(header);
        group.appendChild(variantsEl);
        productResultsEl.appendChild(group);

        let variantsLoaded = false;

        toggleBtn.addEventListener('click', () => {
          const isCollapsed = variantsEl.classList.contains('is-collapsed');

          variantsEl.classList.toggle('is-collapsed', !isCollapsed);
          toggleBtn.classList.toggle('is-open', isCollapsed);
          toggleBtn.setAttribute('aria-expanded', String(isCollapsed));

          if (isCollapsed && !variantsLoaded) {
            variantsLoaded = true;
            const loading = document.createElement('div');
            loading.className = 'byos-form__product-variants-loading';
            loading.textContent = 'Loading options…';
            variantsEl.appendChild(loading);
            fetchProductVariants(product, variantsEl);
          }
        });
      });
    }

    function fetchProductVariants(product, variantsEl) {
      fetch(`/products/${product.handle}.js`, { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((data) => {
          renderProductVariants(product, (data && data.variants) || [], variantsEl);
        })
        .catch(() => {
          renderProductVariants(product, [], variantsEl);
        });
    }

    function renderProductVariants(product, variants, variantsEl) {
      variantsEl.innerHTML = '';

      if (!variants.length) {
        const empty = document.createElement('div');
        empty.className = 'byos-form__product-variants-empty';
        empty.textContent = 'No options available.';
        variantsEl.appendChild(empty);
        return;
      }

      variants.forEach((variant) => {
        const optionLabel = document.createElement('label');
        optionLabel.className = 'byos-form__product-variant';

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `product-variant-${product.id}`;
        radio.value = String(variant.id);

        const text = document.createElement('span');
        text.textContent = variant.title === 'Default Title' ? product.title : variant.title;

        optionLabel.appendChild(radio);
        optionLabel.appendChild(text);
        variantsEl.appendChild(optionLabel);
      });
    }

    function performProductSearch(term) {
      renderProductResultsEmpty('Searching…');

      const searchParams = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'last'
      });

      fetch(`/search/suggest.json?${searchParams.toString()}`, {
        headers: { Accept: 'application/json' }
      })
        .then((res) => res.json())
        .then((data) => {
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          renderProductResults(products);
        })
        .catch(() => {
          renderProductResults([]);
        });
    }

    productSearchInput.addEventListener('input', () => {
      clearTimeout(productSearchDebounce);
      const term = productSearchInput.value.trim();

      if (term.length < 2) {
        renderProductResultsEmpty();
        return;
      }

      productSearchDebounce = setTimeout(() => performProductSearch(term), 300);
    });

    productResultsEl.addEventListener('change', (e) => {
      const radio = e.target.closest('.byos-form__product-variant input[type="radio"]');
      if (!radio) return;

      const group = radio.closest('.byos-form__product-group');
      if (!group) return;

      const productId = group.dataset.productId;
      const productTitle = group.querySelector('.byos-form__product-header span').textContent;
      const variantLabel = radio.parentElement.querySelector('span').textContent;

      pendingProductSelections.set(productId, { productTitle, variantLabel });
      productDoneBtn.disabled = pendingProductSelections.size === 0;
    });

    function createProductChip(title) {
      const chip = document.createElement('span');
      chip.className = 'byos-form__product-chip';

      const label = document.createElement('span');
      label.textContent = title;

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'byos-form__product-remove';
      removeBtn.textContent = '×';

      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.className = 'byos-form__product-value';
      hidden.value = title;

      chip.appendChild(label);
      chip.appendChild(removeBtn);
      chip.appendChild(hidden);
      return chip;
    }

    function openProductModal(targetList) {
      activeProductsList = targetList;
      pendingProductSelections.clear();
      productSearchInput.value = '';
      renderProductResultsEmpty();
      productDoneBtn.disabled = true;
      productModal.classList.add('is-open');
      productSearchInput.focus();
    }

    function closeProductModal() {
      productModal.classList.remove('is-open');
      activeProductsList = null;
      pendingProductSelections.clear();
    }

    productCloseBtn.addEventListener('click', closeProductModal);
    productCancelBtn.addEventListener('click', closeProductModal);
    productModal.addEventListener('click', (e) => {
      if (e.target === productModal) closeProductModal();
    });

    productDoneBtn.addEventListener('click', () => {
      if (!activeProductsList || pendingProductSelections.size === 0) return;

      const existingTitles = new Set(
        Array.from(activeProductsList.querySelectorAll('.byos-form__product-value')).map((el) => el.value)
      );

      pendingProductSelections.forEach(({ productTitle, variantLabel }) => {
        const label = variantLabel && variantLabel !== productTitle ? `${productTitle} - ${variantLabel}` : productTitle;
        if (!existingTitles.has(label)) {
          activeProductsList.appendChild(createProductChip(label));
          existingTitles.add(label);
        }
      });

      const productsWrapper = activeProductsList.closest('.byos-form__products');
      if (productsWrapper) productsWrapper.classList.remove('is-invalid');
      maybeHideSubmitError();

      closeProductModal();
    });

    function sendSignatureToAppScript(payload) {
      if (!BYOS_APP_SCRIPT_URL || BYOS_APP_SCRIPT_URL.includes('G43HKJ8hkkKN64BKJzmJTGDF175sagGDHS789DSgd9s')) {
        console.warn('BYOS Apps Script URL is not configured.');
        return Promise.resolve({ success: false, message: 'URL not configured' });
      }

      return fetch(BYOS_APP_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload),
        mode: 'no-cors'
      }).then(() => ({ success: true }));
    }

    function validateCustomizations(markInvalid) {
      const blocks = Array.from(wrapper.querySelectorAll('.byos-form__customization'));
      const generalErrors = [];
      const customizationErrors = [];
      let firstInvalidEl = null;

      if (blocks.length === 0) {
        generalErrors.push('Add at least 1 customization.');
      }

      blocks.forEach((block, index) => {
        const uid = block.dataset.uid;
        const isCapBlock = block.classList.contains('cap');
        const issues = [];
        const productsList = block.querySelector('.byos-form__products-list');
        const productsWrapper = block.querySelector('.byos-form__products');
        const hasProduct = !!productsList && !!productsList.querySelector('.byos-form__product-value');

        if (markInvalid && productsWrapper) {
          productsWrapper.classList.toggle('is-invalid', !hasProduct);
        }

        if (!hasProduct) {
          issues.push('Add at least 1 product.');
          if (!firstInvalidEl) firstInvalidEl = block.querySelector('.byos-form__add-product');
        }

        if (isCapBlock) {
          const initialsInput = block.querySelector(`#initials-${uid}`);
          const hasInitials = !!initialsInput && initialsInput.value.trim().length > 0;

          if (markInvalid && initialsInput) {
            initialsInput.classList.toggle('is-invalid', !hasInitials);
          }

          if (!hasInitials) {
            issues.push('Initials is required.');
            if (!firstInvalidEl) firstInvalidEl = initialsInput;
          }
        } else {
          const contentSelectors = [
            `#first-line-${uid}`,
            `#second-line-${uid}`,
            `#notes-${uid}`,
            `#back-first-line-${uid}`,
            `#back-second-line-${uid}`,
            `#back-notes-${uid}`
          ];
          const hasContent = contentSelectors.some((sel) => getByosFieldValue(block, sel).length > 0);

          if (markInvalid) {
            contentSelectors.forEach((sel) => {
              const el = block.querySelector(sel);
              if (el) el.classList.toggle('is-invalid', !hasContent);
            });
          }

          if (!hasContent) {
            issues.push('Enter at least one line of text or a note.');
            if (!firstInvalidEl) firstInvalidEl = block.querySelector(`#first-line-${uid}`);
          }
        }

        if (issues.length) {
          customizationErrors.push({ label: `Customization ${index + 1}`, issues });
        }
      });

      return {
        valid: generalErrors.length === 0 && customizationErrors.length === 0,
        generalErrors,
        customizationErrors,
        firstInvalidEl
      };
    }

    function maybeHideSubmitError() {
      const orderValid = !orderInput || orderInput.classList.contains('is-valid');
      const nameValid = !nameInput || nameInput.classList.contains('is-valid');
      const customizationCheck = validateCustomizations(false);
      if (orderValid && nameValid && customizationCheck.valid) hideSubmitError();
    }

    function updateOrderValidity() {
      if (!orderInput) return;
      const digitsOnly = orderInput.value.replace(/\D/g, '');
      const valid = digitsOnly.length === 6;
      orderInput.classList.toggle('is-valid', valid);
      if (valid) orderInput.classList.remove('is-invalid');
      maybeHideSubmitError();
    }

    if (orderInput) {
      orderInput.addEventListener('input', updateOrderValidity);
      updateOrderValidity();
    }

    function updateNameValidity() {
      if (!nameInput) return;
      const valid = nameInput.value.trim().length > 0;
      nameInput.classList.toggle('is-valid', valid);
      if (valid) nameInput.classList.remove('is-invalid');
      maybeHideSubmitError();
    }

    if (nameInput) {
      nameInput.addEventListener('input', updateNameValidity);
      updateNameValidity();
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function updateEmailValidity() {
      if (!emailInput) return;
      emailInput.classList.toggle('is-valid', emailPattern.test(emailInput.value.trim()));
    }

    if (emailInput) {
      emailInput.addEventListener('input', updateEmailValidity);
      updateEmailValidity();
    }

    let uidCounter = 0;

    function renumberCustomizations() {
      const blocks = wrapper.querySelectorAll('.byos-form__customization');

      blocks.forEach((block, i) => {
        block.querySelector('.byos-form__group-title').textContent = `Customization ${i + 1}`;
        block.setAttribute('data-uid', i + 1);
        block.querySelectorAll('input').forEach((input) => {
          const oldId = input.id;

          input.name = input.name.replace(/-\d+$/, `-${i + 1}`);
          input.id = oldId.replace(/-\d+$/, `-${i + 1}`);

          const label = block.querySelector(`label[for="${oldId}"]`);
          if (label) {
            label.htmlFor = input.id;
          }
        });
      });
    }

    function updateReserveLineState(checkbox) {
      const block = checkbox.closest('.byos-form__customization');
      if (!block) return;

      const panel = checkbox.closest('.byos-form__side-panel');
      const disabled = checkbox.checked;
      const prefix = panel?.dataset.sidePanel === 'back' ? 'back-' : '';

      block.querySelectorAll(`.byos-form__side-panel${panel ? `[data-side-panel="${panel.dataset.sidePanel}"]` : ''} .byos-form__field-group.text.second-line input`).forEach((input) => {
        input.disabled = disabled;
      });

      block.querySelectorAll(`.byos-form__side-panel${panel ? `[data-side-panel="${panel.dataset.sidePanel}"]` : ''} .byos-form__text-customization.second-line input`).forEach((input) => {
        input.disabled = disabled;
      });

      const secondLineInput = block.querySelector(`#${prefix}second-line-${block.dataset.uid}`);
      if (secondLineInput) {
        secondLineInput.disabled = disabled;
      }
    }

    function buildRegularPanelMarkup(uid, prefix = '', includePlacement = true) {
      const panelPrefix = prefix ? `${prefix}-` : '';
      const placementMarkup = includePlacement ? `
      <div class="byos-form__style-group radio">
        <div class="byos-form__group-label">PLACEMENT</div>

        <div class="byos-form__input-group">
          <div class="byos-form__field-group radio-group">
            <input value="Left" id="${panelPrefix}placement-1-${uid}" name="${panelPrefix}placement-${uid}" type="radio" checked required>
            <label for="${panelPrefix}placement-1-${uid}" class="byos-form__label" checked>Left</label>
          </div>

          <div class="byos-form__field-group radio-group">
            <input value="Right" id="${panelPrefix}placement-2-${uid}" name="${panelPrefix}placement-${uid}" type="radio">
            <label for="${panelPrefix}placement-2-${uid}" class="byos-form__label">Right</label>
          </div>
        </div>
      </div>` : '';

      return `
      ${placementMarkup}
      <div class="byos-form__field-group text first-line">
        <label class="byos-form__label" for="${panelPrefix}first-line-${uid}">FIRST LINE</label>
        <input type="text" id="${panelPrefix}first-line-${uid}" placeholder="Jane Doe" maxlength="28">
      </div>

      <div class="byos-form__text-customization first-line">
        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">CASE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="AS TYPED" id="${panelPrefix}first-case-1-${uid}" name="${panelPrefix}first-case-${uid}" type="radio" checked>
              <label for="${panelPrefix}first-case-1-${uid}" class="byos-form__label" checked>N/A</label>
            </div>
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="Title Case" id="${panelPrefix}first-case-2-${uid}" name="${panelPrefix}first-case-${uid}" type="radio">
              <label for="${panelPrefix}first-case-2-${uid}" class="byos-form__label">Aa</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="UPPERCASE" id="${panelPrefix}first-case-3-${uid}" name="${panelPrefix}first-case-${uid}" type="radio">
              <label for="${panelPrefix}first-case-3-${uid}" class="byos-form__label">AA</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="lowercase" id="${panelPrefix}first-case-4-${uid}" name="${panelPrefix}first-case-${uid}" type="radio">
              <label for="${panelPrefix}first-case-4-${uid}" class="byos-form__label">aa</label>
            </div>
          </div>
        </div>

        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">STYLE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input value="Block" id="${panelPrefix}first-style-1-${uid}" name="${panelPrefix}first-style-${uid}" type="radio" checked>
              <label for="${panelPrefix}first-style-1-${uid}" class="byos-form__label" checked>Block</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input value="Script" id="${panelPrefix}first-style-2-${uid}" name="${panelPrefix}first-style-${uid}" type="radio">
              <label for="${panelPrefix}first-style-2-${uid}" class="byos-form__label">Script</label>
            </div>
          </div>
        </div>
      </div>

      <div class="byos-form__field-group text second-line">
        <label class="byos-form__label" for="${panelPrefix}second-line-${uid}">SECOND LINE</label>
        <input type="text" id="${panelPrefix}second-line-${uid}" placeholder="PEDIATRICIAN" maxlength="28">
      </div>

      <div class="byos-form__field-group checkbox reserve-line">
        <input type="checkbox" id="${panelPrefix}reserve-line-${uid}" class="byos-form__reserve-line" data-side="${prefix ? 'back' : 'front'}">
        <label class="byos-form__label" for="${panelPrefix}reserve-line-${uid}">
          Leave space for future embroidery.
        </label>
      </div>

      <div class="byos-form__text-customization second-line">
        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">CASE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="AS TYPED" id="${panelPrefix}second-case-1-${uid}" name="${panelPrefix}second-case-${uid}" type="radio" checked>
              <label for="${panelPrefix}second-case-1-${uid}" class="byos-form__label" checked>N/A</label>
            </div>
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="Title Case" id="${panelPrefix}second-case-2-${uid}" name="${panelPrefix}second-case-${uid}" type="radio">
              <label for="${panelPrefix}second-case-2-${uid}" class="byos-form__label">Aa</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="UPPERCASE" id="${panelPrefix}second-case-3-${uid}" name="${panelPrefix}second-case-${uid}" type="radio">
              <label for="${panelPrefix}second-case-3-${uid}" class="byos-form__label">AA</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="lowercase" id="${panelPrefix}second-case-4-${uid}" name="${panelPrefix}second-case-${uid}" type="radio">
              <label for="${panelPrefix}second-case-4-${uid}" class="byos-form__label">aa</label>
            </div>
          </div>
        </div>

        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">STYLE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input value="Block" id="${panelPrefix}second-style-1-${uid}" name="${panelPrefix}second-style-${uid}" type="radio" checked>
              <label for="${panelPrefix}second-style-1-${uid}" class="byos-form__label" checked>Block</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input value="Script" id="${panelPrefix}second-style-2-${uid}" name="${panelPrefix}second-style-${uid}" type="radio">
              <label for="${panelPrefix}second-style-2-${uid}" class="byos-form__label">Script</label>
            </div>
          </div>
        </div>
      </div>

      <div class="byos-form__style-group radio">
        <div class="byos-form__group-label">THREAD COLOR</div>

        <div class="byos-form__color-group-label">BASIC</div>

        <div class="byos-form__input-group color">
          <div class="byos-form__field-group radio-group color">
            <input value="Black" class="byos-form__color" id="${panelPrefix}color-1-${uid}" name="${panelPrefix}color-${uid}" type="radio" checked>
            <label for="${panelPrefix}color-1-${uid}" class="byos-form__color-label" checked style="background-color: black!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Navy" class="byos-form__color" id="${panelPrefix}color-2-${uid}" name="${panelPrefix}color-${uid}" type="radio">
            <label for="${panelPrefix}color-2-${uid}" class="byos-form__color-label" checked style="background-color: #233C75!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="White" class="byos-form__color" id="${panelPrefix}color-3-${uid}" name="${panelPrefix}color-${uid}" type="radio">
            <label for="${panelPrefix}color-3-${uid}" class="byos-form__color-label" style="background-color: white!important"></label>
          </div>
        </div>

        <div class="byos-form__color-group-label">SPECIAL</div>

        <div class="byos-form__input-group color">
          <div class="byos-form__field-group radio-group color">
            <input value="Graphite" class="byos-form__color" id="${panelPrefix}color-4-${uid}" name="${panelPrefix}color-${uid}" type="radio" >
            <label for="${panelPrefix}color-4-${uid}" class="byos-form__color-label" checked style="background-color: #504F55!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Cobalt Blue" class="byos-form__color" id="${panelPrefix}color-5-${uid}" name="${panelPrefix}color-${uid}" type="radio">
            <label for="${panelPrefix}color-5-${uid}" class="byos-form__color-label" style="background-color: #0046B6!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Merlot" class="byos-form__color" id="${panelPrefix}color-6-${uid}" name="${panelPrefix}color-${uid}" type="radio" >
            <label for="${panelPrefix}color-6-${uid}" class="byos-form__color-label" checked style="background-color: #5F263B!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Mauve" class="byos-form__color" id="${panelPrefix}color-7-${uid}" name="${panelPrefix}color-${uid}" type="radio" >
            <label for="${panelPrefix}color-7-${uid}" class="byos-form__color-label" checked style="background-color: #9F687F!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Forest Green" class="byos-form__color" id="${panelPrefix}color-8-${uid}" name="${panelPrefix}color-${uid}" type="radio" >
            <label for="${panelPrefix}color-8-${uid}" class="byos-form__color-label" checked style="background-color: #5A4C29!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Pacific Tid" class="byos-form__color" id="${panelPrefix}color-9-${uid}" name="${panelPrefix}color-${uid}" type="radio" >
            <label for="${panelPrefix}color-9-${uid}" class="byos-form__color-label" checked style="background-color: #003A40!important"></label>
          </div>
        </div>
      </div>
      <div class="byos-form__field-group text">
        <label class="byos-form__label" for="${panelPrefix}notes-${uid}">NOTES</label>
        <textarea id="${panelPrefix}notes-${uid}" placeholder="Custom instructions, product names, logo name/location etc."></textarea>
      </div>`;
    }

    function buildCustomizationBlock(type) {
      uidCounter += 1;
      const uid = uidCounter;

      const div = document.createElement('div');
      div.classList.add('byos-form__customization', 'byos-form__group');
      div.classList.add(type === 'cap' ? 'cap' : 'regular');
      div.dataset.uid = uid;

      let textCustomization;

      if (type === 'cap') {
        textCustomization = `
      <div class="byos-form__field-group text initial">
        <label class="byos-form__label" for="initials-${uid}">INITIALS</label>
        <input type="text" id="initials-${uid}" placeholder="JCD" required maxlength="3">
      </div>

      <div class="byos-form__text-customization initials">
        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">CASE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="AS TYPED" id="initials-case-1-${uid}" name="initials-case-${uid}" type="radio" checked>
              <label for="initials-case-1-${uid}" class="byos-form__label" checked>N/A</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="Title Case" id="initials-case-2-${uid}" name="initials-case-${uid}" type="radio">
              <label for="initials-case-2-${uid}" class="byos-form__label">Aa</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="UPPERCASE" id="initials-case-3-${uid}" name="initials-case-${uid}" type="radio">
              <label for="initials-case-3-${uid}" class="byos-form__label">AA</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="lowercase" id="initials-case-4-${uid}" name="initials-case-${uid}" type="radio">
              <label for="initials-case-4-${uid}" class="byos-form__label">aa</label>
            </div>
          </div>
        </div>

        <div class="byos-form__style-group radio">
          <div class="byos-form__group-label">STYLE</div>

          <div class="byos-form__input-group">
            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="Block" id="initials-style-1-${uid}" name="initials-style-${uid}" type="radio" checked>
              <label for="initials-style-1-${uid}" class="byos-form__label" checked>Block</label>
            </div>

            <div class="byos-form__field-group radio-group">
              <input class="byos-form__case" value="Script" id="initials-style-2-${uid}" name="initials-style-${uid}" type="radio">
              <label for="initials-style-2-${uid}" class="byos-form__label">Script</label>
            </div>
          </div>
        </div>

      </div>

      <div class="byos-form__style-group radio">
        <div class="byos-form__group-label">THREAD COLOR</div>

        <div class="byos-form__color-group-label">BASIC</div>

        <div class="byos-form__input-group color">
          <div class="byos-form__field-group radio-group color">
            <input value="Black" class="byos-form__color" id="color-1-${uid}" name="color-${uid}" type="radio" checked>
            <label for="color-1-${uid}" class="byos-form__color-label" checked style="background-color: black!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Navy" class="byos-form__color" id="color-2-${uid}" name="color-${uid}" type="radio">
            <label for="color-2-${uid}" class="byos-form__color-label" checked style="background-color: #233C75!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="White" class="byos-form__color" id="color-3-${uid}" name="color-${uid}" type="radio">
            <label for="color-3-${uid}" class="byos-form__color-label" style="background-color: white!important"></label>
          </div>
        </div>

        <div class="byos-form__color-group-label">SPECIAL</div>

        <div class="byos-form__input-group color">
          <div class="byos-form__field-group radio-group color">
            <input value="Graphite" class="byos-form__color" id="color-4-${uid}" name="color-${uid}" type="radio" >
            <label for="color-4-${uid}" class="byos-form__color-label" checked style="background-color: #504F55!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Cobalt Blue" class="byos-form__color" id="color-5-${uid}" name="color-${uid}" type="radio">
            <label for="color-5-${uid}" class="byos-form__color-label" style="background-color: #0046B6!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Merlot" class="byos-form__color" id="color-6-${uid}" name="color-${uid}" type="radio" >
            <label for="color-6-${uid}" class="byos-form__color-label" checked style="background-color: #5F263B!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Mauve" class="byos-form__color" id="color-7-${uid}" name="color-${uid}" type="radio" >
            <label for="color-7-${uid}" class="byos-form__color-label" checked style="background-color: #9F687F!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Forest Green" class="byos-form__color" id="color-8-${uid}" name="color-${uid}" type="radio" >
            <label for="color-8-${uid}" class="byos-form__color-label" checked style="background-color: #5A4C29!important"></label>
          </div>

          <div class="byos-form__field-group radio-group color">
            <input value="Pacific Tid" class="byos-form__color" id="color-9-${uid}" name="color-${uid}" type="radio" >
            <label for="color-9-${uid}" class="byos-form__color-label" checked style="background-color: #003A40!important"></label>
          </div>
        </div>
      </div>

      <div class="byos-form__field-group text">
        <label class="byos-form__label" for="notes-${uid}">NOTES</label>
        <textarea id="notes-${uid}" placeholder="Custom instructions, product names, logo name/location etc."></textarea>
      </div>
    `;
      } else if (type === 'regular') {
        textCustomization = `
      <div class="byos-form__side-tabs">
        <button type="button" class="byos-form__side-tab is-active" data-side="front">Front</button>
        <button type="button" class="byos-form__side-tab" data-side="back">Back</button>
      </div>
      <div class="byos-form__side-panels">
        <div class="byos-form__side-panel is-active" data-side-panel="front">
          ${buildRegularPanelMarkup(uid, '', true)}
        </div>
        <div class="byos-form__side-panel" data-side-panel="back">
          ${buildRegularPanelMarkup(uid, 'back', false)}
        </div>
      </div>
    `;
      }

      div.innerHTML = `
    <button type="button" class="byos-form__remove-customization">×</button>
    <h2 class="byos-form__group-title">Customization</h2>
    <div class="byos-form__products">
      <div class="byos-form__products-list"></div>
      <button type="button" class="byos-form__add-product">+ Add product</button>
    </div>
    <div class="byos-form__customization-group">
      ${textCustomization}
    </div>
  `;

      return div;
    }

    addButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.classList.contains('cap') ? 'cap' : 'regular';
        const block = buildCustomizationBlock(type);
        wrapper.appendChild(block);
        renumberCustomizations();
        maybeHideSubmitError();
      });
    });

    let tappedRadio = null;

    function applyCaseValue(value, caseValue) {
      switch (caseValue) {
        case 'UPPERCASE':
          return value.toUpperCase();
        case 'lowercase':
          return value.toLowerCase();
        case 'Title Case':
          return value.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        case 'AS TYPED':
        default:
          return value;
      }
    }

    function caseToCssTextTransform(caseValue) {
      switch (caseValue) {
        case 'UPPERCASE':
          return 'uppercase';
        case 'lowercase':
          return 'lowercase';
        case 'Title Case':
          return 'capitalize';
        case 'AS TYPED':
        default:
          return '';
      }
    }

    function getTextCaseFieldContext(radioName) {
      const match = radioName.match(/^(back-)?(first|second|initials)-(case|style)-(\d+)$/);
      if (!match) return null;

      const [, backPrefix, field, , uid] = match;
      const prefix = backPrefix || '';
      const textInputId = field === 'initials' ? `initials-${uid}` : `${prefix}${field}-line-${uid}`;

      return {
        textInputId,
        caseName: `${prefix}${field}-case-${uid}`,
        styleName: `${prefix}${field}-style-${uid}`
      };
    }

    function applyTextCaseFromRadio(radio) {
      const context = getTextCaseFieldContext(radio.name);
      if (!context) return;

      const block = radio.closest('.byos-form__customization');
      if (!block) return;

      const textInput = block.querySelector(`#${context.textInputId}`);
      if (!textInput) return;

      const checkedCase = block.querySelector(`[name="${context.caseName}"]:checked`);
      const checkedStyle = block.querySelector(`[name="${context.styleName}"]:checked`);
      const caseValue = checkedCase ? checkedCase.value : 'AS TYPED';
      const isScript = checkedStyle ? checkedStyle.value === 'Script' : false;

      // Style only controls the font; Case controls both the baked value and
      // the live visual casing, so they no longer fight each other.
      textInput.value = applyCaseValue(textInput.value, caseValue);
      textInput.style.setProperty('font-family', isScript ? '"Leckerli One"' : '', 'important');

      const cssTransform = caseToCssTextTransform(caseValue);
      if (cssTransform) {
        textInput.style.setProperty('text-transform', cssTransform, 'important');
      } else {
        textInput.style.removeProperty('text-transform');
      }
    }

    wrapper.addEventListener('change', (e) => {
      if (e.target.classList.contains('byos-form__reserve-line')) {
        updateReserveLineState(e.target);
      }

      if (e.target.type === 'radio' && e.target.name) {
        applyTextCaseFromRadio(e.target);
      }
    });

    function clearRegularContentInvalid(block) {
      const uid = block.dataset.uid;
      const contentSelectors = [
        `#first-line-${uid}`,
        `#second-line-${uid}`,
        `#notes-${uid}`,
        `#back-first-line-${uid}`,
        `#back-second-line-${uid}`,
        `#back-notes-${uid}`
      ];
      const hasContent = contentSelectors.some((sel) => getByosFieldValue(block, sel).length > 0);

      if (hasContent) {
        contentSelectors.forEach((sel) => {
          const el = block.querySelector(sel);
          if (el) el.classList.remove('is-invalid');
        });
      }
    }

    wrapper.addEventListener('input', (e) => {
      const initialsGroup = e.target.closest('.byos-form__field-group.text.initial');
      if (initialsGroup && e.target.tagName === 'INPUT') {
        if (e.target.value.trim().length > 0) {
          e.target.classList.remove('is-invalid');
        }
        maybeHideSubmitError();
        return;
      }

      const regularBlock = e.target.closest('.byos-form__customization.regular');
      if (regularBlock && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
        clearRegularContentInvalid(regularBlock);
        maybeHideSubmitError();
      }
    });

    wrapper.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.byos-form__remove-customization');
      const tabBtn = e.target.closest('.byos-form__side-tab');
      const addProductBtn = e.target.closest('.byos-form__add-product');
      const removeProductBtn = e.target.closest('.byos-form__product-remove');

      if (removeBtn) {
        const block = removeBtn.closest('.byos-form__customization');
        if (block) {
          block.remove();
          renumberCustomizations();
          maybeHideSubmitError();
        }
        return;
      }

      if (addProductBtn) {
        const block = addProductBtn.closest('.byos-form__customization');
        const list = block?.querySelector('.byos-form__products-list');
        if (list) openProductModal(list);
        return;
      }

      if (removeProductBtn) {
        removeProductBtn.closest('.byos-form__product-chip')?.remove();
        return;
      }

      if (tabBtn) {
        const block = tabBtn.closest('.byos-form__customization');
        if (!block) return;

        block.querySelectorAll('.byos-form__side-tab').forEach((btn) => {
          btn.classList.toggle('is-active', btn === tabBtn);
        });

        block.querySelectorAll('.byos-form__side-panel').forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.sidePanel === tabBtn.dataset.side);
        });
      }
    });

    const signatureModal = document.getElementById('byos-form__signature-modal');
    const signatureBackBtn = document.getElementById('byos-form__signature-back');
    const signatureCanvas = document.getElementById('byos-form__signature-canvas');
    const signatureClearBtn = document.getElementById('byos-form__signature-clear');
    const signatureSubmitBtn = document.getElementById('byos-form__signature-submit');
    const signatureInput = document.getElementById('byos-form__signature-input');

    if (!submitBtn || !signatureModal || !signatureCanvas || !signatureClearBtn || !signatureSubmitBtn || !signatureInput) {
      return;
    }

    const signatureCtx = signatureCanvas.getContext('2d');
    const signatureCanvasStyle = getComputedStyle(signatureCanvas);
    signatureCtx.lineWidth = parseFloat(signatureCanvasStyle.getPropertyValue('--signature-line-width')) || 2;
    signatureCtx.lineCap = signatureCanvasStyle.getPropertyValue('--signature-line-cap').trim() || 'round';
    signatureCtx.strokeStyle = signatureCanvasStyle.getPropertyValue('--signature-stroke-color').trim() || '#111';

    let signatureDrawing = false;
    let signatureDrawn = false;

    function getSignaturePos(e) {
      const rect = signatureCanvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    }

    signatureCanvas.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      signatureDrawing = true;
      signatureDrawn = true;
      signatureSubmitBtn.disabled = false;
      const pos = getSignaturePos(e);
      signatureCtx.beginPath();
      signatureCtx.moveTo(pos.x, pos.y);
    });

    signatureCanvas.addEventListener('pointermove', (e) => {
      if (!signatureDrawing) return;
      e.preventDefault();
      const pos = getSignaturePos(e);
      signatureCtx.lineTo(pos.x, pos.y);
      signatureCtx.stroke();
    });

    window.addEventListener('pointerup', () => {
      signatureDrawing = false;
    });

    function clearSignature() {
      signatureCtx.clearRect(0, 0, signatureCanvas.width, signatureCanvas.height);
      signatureDrawn = false;
      signatureSubmitBtn.disabled = true;
    }

    function openSignatureModal() {
      signatureModal.classList.add('is-open');
    }

    function closeSignatureModal() {
      signatureModal.classList.remove('is-open');
    }

    submitBtn.addEventListener('click', () => {
      const orderValid = !orderInput || orderInput.classList.contains('is-valid');
      const nameValid = !nameInput || nameInput.classList.contains('is-valid');

      if (!orderValid) orderInput.classList.add('is-invalid');
      if (!nameValid) nameInput.classList.add('is-invalid');

      const customizationCheck = validateCustomizations(true);

      if (!orderValid || !nameValid || !customizationCheck.valid) {
        const missing = [];
        if (!orderValid) missing.push('Order Number');
        if (!nameValid) missing.push('Name');

        const summaryLines = [];
        if (missing.length) {
          summaryLines.push(`${missing.join(' and ')} ${missing.length > 1 ? 'are' : 'is'} required.`);
        }
        summaryLines.push(...customizationCheck.generalErrors);

        showSubmitError({ summaryLines, customizationErrors: customizationCheck.customizationErrors });

        const focusTarget = !orderValid ? orderInput : !nameValid ? nameInput : customizationCheck.firstInvalidEl;
        focusTarget?.focus();
        return;
      }

      hideSubmitError();
      openSignatureModal();
    });
    signatureBackBtn.addEventListener('click', closeSignatureModal);
    signatureClearBtn.addEventListener('click', clearSignature);

    signatureSubmitBtn.addEventListener('click', () => {
      if (!signatureDrawn) return;
      signatureCtx.globalCompositeOperation = 'destination-over';
      signatureCtx.fillStyle = signatureCanvasStyle.backgroundColor;
      signatureCtx.fillRect(0, 0, signatureCanvas.width, signatureCanvas.height);
      signatureInput.value = signatureCanvas.toDataURL('image/jpeg', 1.0);
      closeSignatureModal();

      const forms = Array.from(document.querySelectorAll('.byos-form__customization'));

      const groupedForms = forms.map((form) => {
        const uid = parseInt(form.dataset.uid, 10);

        const collectSideValues = (prefix = '') => {
          const panelPrefix = prefix ? `${prefix}-` : '';
          const reserveLine = !!form.querySelector(`#${panelPrefix}reserve-line-${uid}`)?.checked;

          return {
            placement: prefix ? '' : form.querySelector(`[name=placement-${uid}]:checked`)?.value || '',
            firstLine: getByosFieldValue(form, `#${panelPrefix}first-line-${uid}`),
            secondLine: getByosFieldValue(form, `#${panelPrefix}second-line-${uid}`),
            initials: getByosFieldValue(form, `#${panelPrefix}initials-${uid}`),
            firstCase: form.querySelector(`[name=${panelPrefix}first-case-${uid}]:checked`)?.value || '',
            firstStyle: form.querySelector(`[name=${panelPrefix}first-style-${uid}]:checked`)?.value || '',
            secondCase: form.querySelector(`[name=${panelPrefix}second-case-${uid}]:checked`)?.value || '',
            secondStyle: form.querySelector(`[name=${panelPrefix}second-style-${uid}]:checked`)?.value || '',
            initialsCase: form.querySelector(`[name=${panelPrefix}initials-case-${uid}]:checked`)?.value || '',
            initialsStyle: form.querySelector(`[name=${panelPrefix}initials-style-${uid}]:checked`)?.value || '',
            color: form.querySelector(`[name=${panelPrefix}color-${uid}]:checked`)?.value || '',
            notes: getByosFieldValue(form, `#${panelPrefix}notes-${uid}`),
            reserveLine
          };
        };

        const frontValues = collectSideValues();
        const backValues = collectSideValues('back');

        const products = Array.from(form.querySelectorAll('.byos-form__products-list .byos-form__product-value')).map(
          (el) => el.value
        );

        return {
          uid,
          ...frontValues,
          products,
          backFirstLine: backValues.firstLine,
          backSecondLine: backValues.secondLine,
          backInitials: backValues.initials,
          backFirstCase: backValues.firstCase,
          backFirstStyle: backValues.firstStyle,
          backSecondCase: backValues.secondCase,
          backSecondStyle: backValues.secondStyle,
          backInitialsCase: backValues.initialsCase,
          backInitialsStyle: backValues.initialsStyle,
          backColor: backValues.color,
          backNotes: backValues.notes,
          backReserveLine: backValues.reserveLine,
          reserveLine: frontValues.reserveLine
        };
      });

      const payload = {
        secret: BYOS_APP_SCRIPT_SECRET,
        customer: {
          name: nameInput?.value?.trim() || 'Customer',
          email: emailInput?.value?.trim() || 'noreply@placeholder.com'
        },
        orderNumber: orderInput?.value?.trim() || '',
        storeEmail: storeSelect?.value?.trim() || '',
        forms: groupedForms,
        signature: signatureInput.value
      };

      sendSignatureToAppScript(payload)
        .then((response) => {
          console.log('Apps Script request sent', response);
        })
        .catch((error) => {
          console.error('Apps Script request failed', error);
        });
    });
  });
})();
